export default [
    {
        "error_id": "LS-01",
        "data": [
            {
                "cross_section": "185",
                "lower": 4578.3,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "422",
                "lower": 4628.9,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "854",
                "lower": 4418.2,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "891",
                "lower": 4439.9,
                "left": 4974.6,
                "right": 5030.6
            },
            {
                "cross_section": "932",
                "lower": 4477.6,
                "left": 4974.6,
                "right": 5030.6
            },
            {
                "cross_section": "1067",
                "lower": 4534.9,
                "left": 4959.2,
                "right": 5008.7
            },
            {
                "cross_section": "1559",
                "lower": 4736.3,
                "left": 4969.2,
                "right": 5018.7
            },
            {
                "cross_section": "2088",
                "lower": 4780.8,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "2448",
                "lower": 4537.1,
                "left": 4969.2,
                "right": 5018.7
            },
            {
                "cross_section": "2679",
                "lower": 4507.1,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "3149",
                "lower": 4709.5,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "3652",
                "lower": 4746.7,
                "left": 4974.2,
                "right": 5023.7
            },
            {
                "cross_section": "4254",
                "lower": 4716.7,
                "left": 4978.9,
                "right": 5023.1
            },
            {
                "cross_section": "4647",
                "lower": 4665.9,
                "left": 4978.9,
                "right": 5023.1
            },
            {
                "cross_section": "4993",
                "lower": 4548.9,
                "left": 4978.9,
                "right": 5023.1
            },
            {
                "cross_section": "5072",
                "lower": 4518.3,
                "left": 4962.6,
                "right": 5031.4
            },
            {
                "cross_section": "5170",
                "lower": 4499.8,
                "left": 4962.6,
                "right": 5031.4
            },
            {
                "cross_section": "5472",
                "lower": 4717.8,
                "left": 4982.4,
                "right": 5023.3
            },
            {
                "cross_section": "5660",
                "lower": 4840.4,
                "left": 4982.4,
                "right": 5023.3
            },
            {
                "cross_section": "5727",
                "lower": 4845.8,
                "left": 4981.8,
                "right": 5015.9
            },
            {
                "cross_section": "5788",
                "lower": 4893.1,
                "left": 4981.8,
                "right": 5015.9
            },
            {
                "cross_section": "5942",
                "lower": 4842.8,
                "left": 4982.4,
                "right": 5023.3
            },
            {
                "cross_section": "6243",
                "lower": 4824.7,
                "left": 4982.4,
                "right": 5023.3
            },
            {
                "cross_section": "6601",
                "lower": 4687.5,
                "left": 4984.2,
                "right": 5021
            },
            {
                "cross_section": "6948",
                "lower": 4838.8,
                "left": 4989.9,
                "right": 5022.6
            },
            {
                "cross_section": "7538",
                "lower": 4912.3,
                "left": 4978.9,
                "right": 5028
            },
            {
                "cross_section": "8241",
                "lower": 4665.1,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "8557",
                "lower": 4508.2,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "9088",
                "lower": 4721.5,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "9344",
                "lower": 4655.8,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "9796",
                "lower": 4510.6,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "10226",
                "lower": 4771.4,
                "left": 4981.3,
                "right": 5031.1
            },
            {
                "cross_section": "10445",
                "lower": 4820,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "10476",
                "lower": 4805.2,
                "left": 4971.3,
                "right": 5019
            },
            {
                "cross_section": "10594",
                "lower": 4720.6,
                "left": 4971.3,
                "right": 5019
            },
            {
                "cross_section": "10703",
                "lower": 4621.7,
                "left": 4982.5,
                "right": 5020.1
            },
            {
                "cross_section": "10986",
                "lower": 4764.2,
                "left": 4982.5,
                "right": 5015.7
            },
            {
                "cross_section": "11382",
                "lower": 4745.9,
                "left": 4977.2,
                "right": 5020
            },
            {
                "cross_section": "11745",
                "lower": 4752.3,
                "left": 4984.2,
                "right": 5017.8
            },
            {
                "cross_section": "11775",
                "lower": 4756.4,
                "left": 4986.7,
                "right": 5010.7
            },
            {
                "cross_section": "11842",
                "lower": 4767.1,
                "left": 4986.7,
                "right": 5010.7
            },
            {
                "cross_section": "11918",
                "lower": 4812.9,
                "left": 4983.7,
                "right": 5014.3
            },
            {
                "cross_section": "12336",
                "lower": 4661.2,
                "left": 4978.7,
                "right": 5013.4
            },
            {
                "cross_section": "12867",
                "lower": 4514.6,
                "left": 4983.7,
                "right": 5014.3
            },
            {
                "cross_section": "13250",
                "lower": 4726,
                "left": 4989.8,
                "right": 5008.7
            },
            {
                "cross_section": "13613",
                "lower": 4666.3,
                "left": 4989.5,
                "right": 5008.7
            },
            {
                "cross_section": "13973",
                "lower": 4771.7,
                "left": 4987.9,
                "right": 5008.7
            },
            {
                "cross_section": "14036",
                "lower": 4735.5,
                "left": 4988.1,
                "right": 5015.8
            },
            {
                "cross_section": "14090",
                "lower": 4766.2,
                "left": 4988.1,
                "right": 5015.8
            },
            {
                "cross_section": "14139",
                "lower": 4767.3,
                "left": 4991.3,
                "right": 5008.7
            },
            {
                "cross_section": "14295",
                "lower": 4763.6,
                "left": 4991.2,
                "right": 5008.7
            },
            {
                "cross_section": "14487",
                "lower": 4796.9,
                "left": 4991.1,
                "right": 5008.7
            },
            {
                "cross_section": "14716",
                "lower": 4803.4,
                "left": 4991.3,
                "right": 5008.7
            },
            {
                "cross_section": "14996",
                "lower": 4774,
                "left": 4978.39,
                "right": 5024.31
            },
            {
                "cross_section": "15071",
                "lower": 4732.6,
                "left": 4980.51,
                "right": 5022.36
            },
            {
                "cross_section": "15166",
                "lower": 4704.3,
                "left": 4978.94,
                "right": 5023.61
            },
            {
                "cross_section": "15317",
                "lower": 4771,
                "left": 4991.2,
                "right": 5013.7
            },
            {
                "cross_section": "15552",
                "lower": 4712.9,
                "left": 4991.2,
                "right": 5013.7
            },
            {
                "cross_section": "16125",
                "lower": 4879.5,
                "left": 4991.2,
                "right": 5013.7
            },
            {
                "cross_section": "16590",
                "lower": 4783.8,
                "left": 4991.2,
                "right": 5013.7
            },
            {
                "cross_section": "16915",
                "lower": 4748.4,
                "left": 4991.2,
                "right": 5013.8
            },
            {
                "cross_section": "17492",
                "lower": 4346,
                "left": 4984.1,
                "right": 5000.8
            },
            {
                "cross_section": "17882",
                "lower": 4691.7,
                "left": 4994.4,
                "right": 5009.3
            },
            {
                "cross_section": "18220",
                "lower": 4699.8,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "18640",
                "lower": 4750.2,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "18799",
                "lower": 4754.5,
                "left": 4978.3,
                "right": 5027.8
            },
            {
                "cross_section": "18882",
                "lower": 4706.2,
                "left": 4987.6,
                "right": 5027.8
            },
            {
                "cross_section": "19003",
                "lower": 4728.8,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "19257",
                "lower": 4696.5,
                "left": 4989.4,
                "right": 5002.6
            },
            {
                "cross_section": "19541",
                "lower": 4849.3,
                "left": 4987.7,
                "right": 5017.5
            },
            {
                "cross_section": "20143",
                "lower": 4763.8,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "20651",
                "lower": 4777.3,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "21236",
                "lower": 4680.1,
                "left": 4989.4,
                "right": 5001.6
            },
            {
                "cross_section": "21781",
                "lower": 4809.2,
                "left": 4994.4,
                "right": 5006.9
            },
            {
                "cross_section": "22315",
                "lower": 4740.4,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "22711",
                "lower": 4737.8,
                "left": 4991.5,
                "right": 5008.9
            },
            {
                "cross_section": "23052",
                "lower": 4789.5,
                "left": 4994.4,
                "right": 5005.2
            },
            {
                "cross_section": "23483",
                "lower": 4742.4,
                "left": 4989.4,
                "right": 5005
            },
            {
                "cross_section": "23894",
                "lower": 4758.7,
                "left": 4994.4,
                "right": 5006.4
            },
            {
                "cross_section": "24319",
                "lower": 4788,
                "left": 4988.7,
                "right": 5013.5
            },
            {
                "cross_section": "24687",
                "lower": 4796.4,
                "left": 4991.5,
                "right": 5009.4
            },
            {
                "cross_section": "24860",
                "lower": 4759.4,
                "left": 4983.7,
                "right": 5012.7
            },
            {
                "cross_section": "24956",
                "lower": 4710.6,
                "left": 4983.7,
                "right": 5012.7
            },
            {
                "cross_section": "25067",
                "lower": 4760.1,
                "left": 4991.5,
                "right": 5008.9
            },
            {
                "cross_section": "25392",
                "lower": 4780.8,
                "left": 4987,
                "right": 5012.2
            },
            {
                "cross_section": "25881",
                "lower": 4762.7,
                "left": 4991.5,
                "right": 5009
            },
            {
                "cross_section": "26286",
                "lower": 4648.4,
                "left": 4991.5,
                "right": 5008.9
            },
            {
                "cross_section": "26672",
                "lower": 4621.8,
                "left": 4989.9,
                "right": 5013.1
            },
            {
                "cross_section": "27025",
                "lower": 4660.7,
                "left": 4986.4,
                "right": 5014.2
            },
            {
                "cross_section": "27497",
                "lower": 4445.4,
                "left": 4991.5,
                "right": 5008.9
            }
        ]
    }
]